'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Separator } from '@repo/ui';
import { useCallback, useEffect, useRef, useState } from 'react';
interface RiskDisclosureTextProps {
  content: React.ReactNode;
}

// Sticky bottom scroll-fade. Relocated from the vaults-ui extension layer — a
// bespoke component detail with no @repo/tailwind-config equivalent.
// light-dark() switches with the active color scheme.
const SCROLL_INDICATOR_GRADIENT = 'light-dark(linear-gradient(to bottom, rgba(235, 237, 245, 0) 1%, #ebedf5 100%), linear-gradient(to bottom, rgba(21, 24, 26, 0) 1%, rgba(21, 24, 26, 1) 100%))';
const RiskDisclosureText = t0 => {
  const $ = _c(16);
  const {
    content
  } = t0;
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [showSticky, setShowSticky] = useState(false);
  const [atBottom, setAtBottom] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const contentHeight = contentRef.current?.scrollHeight;
      const containerHeight = containerRef.current?.clientHeight;
      if (contentHeight && containerHeight && contentHeight > containerHeight) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const checkContentHeight = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = container;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
      setAtBottom(isAtBottom);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleScroll = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const container_0 = containerRef.current;
      checkContentHeight();
      handleScroll();
      if (container_0) {
        container_0.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", checkContentHeight);
      }
      return () => {
        if (container_0) {
          container_0.removeEventListener("scroll", handleScroll);
          window.removeEventListener("resize", checkContentHeight);
        }
      };
    };
    t4 = [handleScroll, checkContentHeight];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      whiteSpace: "pre-wrap"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== content) {
    t6 = <div className="gap-xs flex flex-col" ref={contentRef}><span className="text-foreground text-xs" style={t5}>{content}</span></div>;
    $[5] = content;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== atBottom || $[8] !== showSticky) {
    t7 = showSticky && <div style={{
      background: SCROLL_INDICATOR_GRADIENT
    }} className={cn("sticky bottom-0 h-[30px] transition-opacity duration-500 ease-[ease]", atBottom ? "opacity-0" : "opacity-100")} />;
    $[7] = atBottom;
    $[8] = showSticky;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div ref={containerRef} className="mt-sm mb-sm max-h-[350px] w-full overflow-auto">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <>{t8}{t9}</>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default RiskDisclosureText;